<ng-container *transloco="let t">
  @let state = state$ | async;

  @if (!state || state.isLoading) {
    <pxc-examinations-skeleton />
  }

  @if (state.isSuccess) {
    @let examinations = examinations$ | async;
    @let hasContent = !!examinations?.length;

    <header
      class="flex items-center! border-b border-border-secondary bg-background-primary-alt pe-[calc(var(--examination-inset,0.5rem)_-_0.5rem)] ps-[calc(var(--examination-inset,1rem)_-_1rem)]"
      tuiHeader="body-s">
      <pxc-examination-selector
        class="flex-1"
        [examinationForms]="examinationForms$ | async"
        [selectedExaminationForm]="selectedExaminationForm$ | async"
        (selectedExaminationFormChange)="selectExaminationForm($event)" />
      @if (hasContent) {
        <pxc-examination-actions />
      }
    </header>
    @if (hasContent) {
      <tui-carousel
        class="[&_.t-item]:items-start!"
        [max]="examinations.length - 1"
        [min]="0"
        [pxcCarouselIndex]="index$ | async"
        (indexChange)="examinationNavigationService.setIndex($event)">
        <ng-template let-index tuiItem>
          @let examination = examinations[index];
          @if (!examination?.formReport) {
            <tui-block-status size="m" [card]="true">
              {{ t('Impossible de charger le contenu de cet examen.') }}
            </tui-block-status>
          } @else {
            <tui-scrollbar class="w-full">
              <div
                class="px-[calc(var(--examination-inset,1rem)_-_1rem)] py-4"
                tuiFade="vertical"
                tuiScrollable
                [class]="scrollableClass()">
                <pxc-form-display
                  class="[&_[tuiCell]]:px-4!"
                  emptyMessage="{{ t('Cet examen ne contient aucune donnée') }}"
                  [alwaysWrap]="true"
                  [sections]="examination.formReport.sections"
                  [showAlerts]="false" />
              </div>
            </tui-scrollbar>
          }
        </ng-template>
      </tui-carousel>
      <pxc-examinations-navigation [class]="navigationClass()">
        <pxc-examination-info [examination]="selectedExamination$ | async" />
      </pxc-examinations-navigation>
    } @else if (canWriteExamination$ | async) {
      @let description = (selectedExaminationForm$ | async)?.description || examinationService.description;
      <pxc-empty-state icon="@tui.clipboard-plus" [description]="description" [title]="t('Ajouter un premier examen')">
        <pxc-examination-actions [actionButtons]="emptyStateActionButtons" />
      </pxc-empty-state>
    } @else {
      <pxc-empty-state [title]="t('Ce patient n\'a aucun examen.')" />
    }
  }

  @if (state.hasError) {
    <tui-block-status size="m" [card]="true">
      <h4>{{ t('Une erreur est survenue lors du chargement des examens.') }}</h4>
      {{ state.error | error }}
    </tui-block-status>
  }
</ng-container>
